import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["wrapperClass", "linkClass", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { BreadcrumbsForFooter } from "@/components/Breadcrumbs";
import Copyrights from "@/components/Copyrights";
import { useAdultModeQuery } from "@/hooks";
import config from "@/lib/config";
import { companyLink, helpLink, maintenanceLink, privacyLink } from "@/lib/constants";
import styles from "@/styles/Footer.module.scss";
import classnames from "classnames";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var XLogo = function XLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("style", {
      type: "text/css",
      children: [".x_logo_footer_svg", "{", "fill:#FFFFFF;", "}"]
    }), /*#__PURE__*/_jsx("path", {
      className: "x_logo_footer_svg",
      d: "M714.2,519.3L1160.9,0H1055L667.1,450.9L357.3,0H0l468.5,681.8L0,1226.4h105.9l409.6-476.2l327.2,476.2H1200 L714.2,519.3L714.2,519.3z M569.2,687.8l-47.5-67.9L144,79.7h162.6l304.8,436l47.5,67.9l396.2,566.7H892.5L569.2,687.8L569.2,687.8z "
    })]
  }));
};

XLogo.defaultProps = {
  version: "1.1",
  id: "レイヤー_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1200 1227",
  style: {
    enableBackground: "new 0 0 1200 1227"
  },
  xmlSpace: "preserve"
};

function FooterLink(props) {
  var wrapperClass = props.wrapperClass,
      linkClass = props.linkClass,
      children = props.children,
      linkProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx("li", {
    className: classnames(styles.wrapper, wrapperClass),
    children: /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
      className: classnames(styles.link)
    }, linkProps), {}, {
      children: children
    }))
  });
}

function FooterUpper(_ref) {
  var isLoginPage = _ref.isLoginPage,
      adultMode = _ref.adultMode;
  if (isLoginPage) return null;
  var help = useMemo(function () {
    return helpLink();
  }, [adultMode]);
  var maintenance = useMemo(function () {
    return maintenanceLink();
  }, [adultMode]);
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(styles.box, " ").concat(styles.upper),
    children: /*#__PURE__*/_jsxs("ul", {
      className: styles.links,
      children: [/*#__PURE__*/_jsx(FooterLink, {
        href: help,
        target: "_blank",
        rel: "noopener noreferrer",
        children: "\u30D8\u30EB\u30D7"
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: "/static/feature/constant/environment",
        children: "\u52D5\u4F5C\u74B0\u5883"
      }), adultMode && /*#__PURE__*/_jsx(FooterLink, {
        href: config.host.vod,
        children: "SPOOX"
      }), !adultMode && /*#__PURE__*/_jsx(FooterLink, {
        href: config.host.adult,
        children: "SPOOX EX"
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: maintenance,
        children: "\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u60C5\u5831"
      }), !adultMode && /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsxs(FooterLink, {
          wrapperClass: styles.twitter,
          linkClass: styles.twitter,
          href: "https://twitter.com/SPOOX_official",
          target: "_blank",
          rel: "noopener noreferrer",
          children: [/*#__PURE__*/_jsx(XLogo, {
            className: styles.Icon
          }), "SPOOX\u516C\u5F0FX\uFF08\u65E7Twitter\uFF09"]
        })
      })]
    })
  });
}

function FooterLower(_ref2) {
  var adultMode = _ref2.adultMode;
  var privacy = useMemo(function () {
    return privacyLink(adultMode);
  }, [adultMode]);
  var year = new Date().getFullYear();
  var company = useMemo(function () {
    return companyLink(adultMode);
  }, [adultMode]);
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(styles.box, " ").concat(styles.lower),
    children: [/*#__PURE__*/_jsxs("ul", {
      className: styles.links,
      children: [/*#__PURE__*/_jsx(FooterLink, {
        href: company,
        target: "_blank",
        rel: "noopener noreferrer",
        children: "\u4F1A\u793E\u6982\u8981"
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: "/static/legal/id_term",
        children: "SPOOX\u4F1A\u54E1\u898F\u7D04"
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: "/static/legal/service_term",
        children: adultMode ? "SPOOX EX利用規約" : "SPOOX利用規約"
      }), !adultMode && /*#__PURE__*/_jsxs(FooterLink, {
        href: "/static/legal/valueplan_term",
        children: [config.valuePlan.text, "\uFF08\u30B9\u30AB\u30D1\u30FC\u5411\u3051\u63D0\u643A\u30E2\u30C7\u30EB\uFF09\u5229\u7528\u898F\u7D04"]
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: privacy,
        target: "_blank",
        rel: "noopener noreferrer",
        children: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC"
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: "/static/legal/sct_law",
        children: "\u7279\u5B9A\u5546\u53D6\u5F15\u6CD5\u306B\u57FA\u3065\u304F\u8868\u8A18\uFF08\u8FD4\u54C1\u7279\u7D04\u542B\u3080\uFF09"
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: "/static/legal/site_policy",
        children: "\u30B5\u30A4\u30C8\u30DD\u30EA\u30B7\u30FC"
      })]
    }), adultMode ? /*#__PURE__*/_jsxs("p", {
      className: styles.copyright,
      children: ["COPYRIGHT \xA9 2011-", year, " SKY PERFECT BROADCASTING CORPORATION ALL RIGHTS RESERVED."]
    }) : /*#__PURE__*/_jsxs("p", {
      className: styles.copyright,
      children: ["COPYRIGHT \xA9 2011-", year, " SKY PERFECT JSAT CORPORATION ALL RIGHTS RESERVED."]
    }), /*#__PURE__*/_jsx(Copyrights, {})]
  });
}

function Footer() {
  var router = useRouter();

  var isLoginPage = function () {
    return router.pathname == "/login";
  }();

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      _useAdultModeQuery$da = _useAdultModeQuery.data;

  _useAdultModeQuery$da = _useAdultModeQuery$da === void 0 ? {} : _useAdultModeQuery$da;
  var adultMode = _useAdultModeQuery$da.adultMode;
  return /*#__PURE__*/_jsxs("footer", {
    className: styles.footer,
    role: "contentinfo",
    children: [/*#__PURE__*/_jsx(BreadcrumbsForFooter, {}), /*#__PURE__*/_jsx(FooterUpper, {
      isLoginPage: isLoginPage,
      adultMode: adultMode
    }), /*#__PURE__*/_jsx(FooterLower, {
      adultMode: adultMode
    })]
  });
}

export default Footer;